import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MetabaseReport, RequestPaginationInfo, ShReportService } from '@stylehaven/components';

import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';

@Injectable()
export class ReportsSandboxService {
    constructor(private readonly reportService: ShReportService) {}

    getReports(paginationInfo: RequestPaginationInfo): Observable<PaginatedResults<MetabaseReport>> {
        return this.reportService.getAll(paginationInfo);
    }
}
